import {saveAs} from "file-saver";
import {useSelector} from "react-redux";
import {Button, Icon, Modal} from "semantic-ui-react";
import {RootState} from "../../app/store";
import {useEffect, useState} from "react";
import {ExportPng} from "../Header/ExportActions";
import {useAppDispatch} from "../../app/hooks";
import {getCurrentTimestamp, orientation, removeDateFromName} from "../../utils/constants";
import { useTranslation } from "react-i18next";
interface Props {
  previewPng: Blob | null | undefined;
  open: boolean;
  onClose: () => void;
}
export const PreviewModal = ({previewPng, open, onClose}: Props) => {
  const {labelParams} = useSelector((state: RootState) => state.labelEdit.present);
  const {labelSizes, templateName} = useSelector((state: RootState) => state.refData);
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  // create and cleanup preview URL
  useEffect(() => {
    if (previewPng) {
      const url = URL.createObjectURL(previewPng);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    } else {
      setPreviewUrl(null);
    }
  }, [previewPng]);
  const handleSavePng = () => {
    if (!previewPng) return;
    let fileName = templateName === null || templateName === undefined || templateName === "" 
      ? `label-${Math.round(Math.random() * 100000000)}.png` : `${templateName}_${getCurrentTimestamp()}.png`;

    fileName = removeDateFromName(fileName);
    saveAs(previewPng, fileName);
  };

  const handlePrint = () => {
    if (!previewPng) return;
    const url = URL.createObjectURL(previewPng);

    let printWindow = window.open("", "_blank");
    if (printWindow) {
      const size = labelSizes.find((size: any) => size.id === labelParams.selectedLabelSizeId);
      if (!size) {
        URL.revokeObjectURL(url);
        return;
      }
      let width = size.width;
      let height = size.height;
      if (labelParams.orientation === orientation.landscape) {
        width = size.height;
        height = size.width;
      }
      printWindow.document.write(`
        <html style="height: 100%;">
          <head>
            <meta name="viewport" content="width=device-width, minimum-scale=0.1">
            <title>label</title>
          </head>
          <body style="margin: 0px; height: 100%; background-color: rgb(14, 14, 14);">
            <img style="background-color: hsl(0, 0%, 90%);transition: background-color 300ms; width: ${width}mm; height: ${height}mm;" src="${url}">
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.onload = function () {
        if (printWindow === null) return;
        printWindow!.print();
        setTimeout(() => {
          printWindow!.close();
          URL.revokeObjectURL(url);
        }, 1000);
      };
    } else {
      URL.revokeObjectURL(url);
    }
  };
  useEffect(() => {
    const handleKeyDown = (event: any) => {
      const code = event.which || event.keyCode;

      let charCode = String.fromCharCode(code).toLowerCase();
      if ((event.ctrlKey || event.metaKey) && charCode === "p") {
        event.preventDefault();
        dispatch(ExportPng()).then((previewPng: Blob | null) => {
          if (!previewPng) return;
          const url = URL.createObjectURL(previewPng);

          let printWindow = window.open("", "_blank");
          if (printWindow) {
            const size = labelSizes.find((size: any) => size.id === labelParams.selectedLabelSizeId);
            if (!size) {
              URL.revokeObjectURL(url);
              return;
            }
            let width = size.width;
            let height = size.height;
            if (labelParams.orientation === orientation.landscape) {
              width = size.height;
              height = size.width;
            }
            printWindow.document.write(`
            <html style="height: 100%;">
              <head>
                <meta name="viewport" content="width=device-width, minimum-scale=0.1">
                <title>label</title>
              </head>
              <body style="margin: 0px; height: 100%; background-color: rgb(14, 14, 14);">
                <img style="background-color: hsl(0, 0%, 90%);transition: background-color 300ms; width: ${width}mm; height: ${height}mm;" src="${url}">
              </body>
            </html>
          `);
            printWindow.document.close();
            printWindow.onload = function () {
              if (printWindow === null) return;
              printWindow!.print();
              setTimeout(() => {
                printWindow!.close();
                URL.revokeObjectURL(url);
              }, 1000);
            };
          } else {
            URL.revokeObjectURL(url);
          }
        });
      } else {
        return;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [dispatch, labelParams.orientation, labelParams.selectedLabelSizeId, labelSizes]);

  return (
    <>
      <Modal size="tiny" open={open} closeIcon onClose={onClose} closeOnDimmerClick>
        <Modal.Header>{t("label_preview")}</Modal.Header>
        <Modal.Content>{previewUrl ? <img style={{border: "1px solid black", width: "inherit"}} src={previewUrl} alt="Preview" /> : <h3 color="danger">{t("error_file_not_found")}</h3>}</Modal.Content>
        <Modal.Actions>
          <Button size="small" color="green" basic onClick={handlePrint} style={{marginLeft: 5}}>
            <Icon name="print" />
            {t("print_btn")}
          </Button>
          <Button size="small" color="green" onClick={handleSavePng} style={{marginLeft: 5}}>
            <Icon name="save" />
            {t("save_png_btn")}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
